import { ArrowRepeat } from 'react-bootstrap-icons';

type PreloaderProps = {
  message?: string;
};

const Preloader: React.FC<PreloaderProps> = ({ message = 'Refrescando datos...' }) => {
  return (
    <div className="flex items-center justify-start">
      <ArrowRepeat className="animate-spin text-xl" />
      <div className="text-md ml-2 py-2">{message}</div>
    </div>
  );
};

export default Preloader;
